import { NavLink } from 'react-router';
import { useCan } from '@/lib/auth/session';
import { cn } from '@/lib/cn';

/** Navegação entre as telas de administração de uma empresa cliente. */
export function CompanyNav({ organizationId }: { organizationId: string }) {
  const can = useCan();
  const items = [
    { to: `/empresas/${organizationId}`, label: 'Visão geral', end: true, show: true },
    {
      to: `/empresas/${organizationId}/areas`,
      label: 'Áreas e unidades',
      end: false,
      show: can('administracao', 'view'),
    },
    {
      to: `/empresas/${organizationId}/usuarios`,
      label: 'Usuários',
      end: false,
      show: can('administracao', 'view'),
    },
    {
      to: `/empresas/${organizationId}/perfis`,
      label: 'Perfis e permissões',
      end: false,
      show: can('administracao', 'view'),
    },
    {
      to: `/empresas/${organizationId}/sso`,
      label: 'Login único (SSO)',
      end: false,
      show: can('administracao', 'view'),
    },
  ].filter((i) => i.show);
  if (items.length < 2) return null;
  return (
    <nav aria-label="Seções da empresa" className="mt-6 overflow-x-auto border-b border-border">
      <ul className="flex min-w-max gap-1">
        {items.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                cn(
                  '-mb-px inline-flex h-11 items-center border-b-2 px-3 text-sm font-semibold transition-colors',
                  isActive
                    ? 'border-brand text-brand-strong dark:text-brand'
                    : 'border-transparent text-muted-foreground hover:text-foreground',
                )
              }
            >
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
